import { Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { getRoutePath } from 'routes/routes'
import { useActiveRole, useInRoute } from 'hooks'

function SectionLinks(_props) {
  const {
    variant = 'h4',
    className = 'justify-start',
    links = [],
    gutterBottom = true,
    children = null,
  } = _props

  const [, { RoleHasAccess }] = useActiveRole()
  const [inRoute] = useInRoute()

  const classes =
    'menu flex-grow flex flex-row space-x-12 ' +
    className +
    ' ' +
    (gutterBottom ? 'mb-8' : '')

  return (
    <div className="flex flex-row justify-between items-center flex-grow">
      <Typography variant={variant} component="ul" className={classes}>
        {links.map(
          (
            {
              label,
              to = false,
              pathName = false,
              roles = [],
            },
            index
          ) => {
            let linkPath = to ? pathName : getRoutePath(pathName)
            return (
              <RoleHasAccess roles={roles} key={index}>
                <li>
                  <Button
                    variant="underlined"
                    component={Link}
                    to={linkPath}
                    className={`${inRoute(linkPath) ? 'active' : ''}`}
                  >
                    {label}
                  </Button>
                </li>
              </RoleHasAccess>
            )
          }
        )}
      </Typography>
      <div className="actions">{children}</div>
    </div>
  )
}

export default SectionLinks
